import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, AlertController } from 'ionic-angular';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { B04InventoryManagementPage } from '../b04-inventory-management/b04-inventory-management';
import { B04cInventoryPage } from '../b04c-inventory/b04c-inventory';
import { ServiceApiProvider } from '../../providers/service-api/service-api';

/**
 * Generated class for the B04aInventoryInfoPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

interface inventoryTypeInfo{
  INVENTORY_TYPE_ID: number;
  NAME: string;
}
interface branchInfo{
  BRANCH_ID: string;
  BRANCH_NAME: string;
  BRANCH_ACTIVE: string;  
}
@IonicPage()
@Component({
  selector: 'page-b04a-inventory-info',
  templateUrl: 'b04a-inventory-info.html',
})
export class B04aInventoryInfoPage {

  private todo : FormGroup;
  loading: any;
  Status: any;
  inventoryTypeArr: inventoryTypeInfo[] = [];
  inventoryTypeItems: inventoryTypeInfo[] = [];
  branchArr: branchInfo[] = [];
  branchItems: branchInfo[] = [];
  inventoryData = { BRANCH_ID:'',INVENTORY_TYPE_ID:'',
                    ITEM_DESC:'',  COST:'',
                    SELLING_PRICE:'', INVENTORY_ACTIVE:'YES',
  }
  mybranchid:any;
  mybranchname:any
  INVENTORY_ID:any;
  BRANCH_ID:any;
  public errorMessage: any = "";

  constructor(public navCtrl: NavController, public navParams: NavParams,
              private formBuilder: FormBuilder, public loadingCtrl: LoadingController,
              public serviceapi: ServiceApiProvider, public alertCtrl : AlertController) {

    this.mybranchid = sessionStorage.getItem('userbranchid');
    if(this.mybranchid == "null")
    {
      this.todo = this.formBuilder.group({
        branch: ['', Validators.required],
        itemDesc: ['', Validators.required],
        cost: ['', Validators.required],
        sellingPrice: ['', Validators.required],
        inventoryType: ['', Validators.required],
        inventoryActive: ['', Validators.required],
      });
    }
    else
    {
      this.todo = this.formBuilder.group({
        branch: [''],
        itemDesc: ['', Validators.required],
        cost: ['', Validators.required],
        sellingPrice: ['', Validators.required],
        inventoryType: ['', Validators.required],
        inventoryActive: ['', Validators.required],
      });
    }

    this.INVENTORY_ID = this.navParams.get('paramID');    //inventory ID

    let tbl = ["INVENTORY"];
    let column = ["INVENTORY_ID"];
    let value = [this.INVENTORY_ID];
    
    let tblkey = ["No"];
    let fktbl = ["No"];
    let fkkey = ["No"];

    let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);
    let mydata = Object.assign(jsonitem);
    let json_data = this.serviceapi.json_readdata(mydata,"1");
    this.showLoader();
    this.serviceapi.readdata(json_data,"INVENTORY","1","1").then((result) => {
        
      this.Status = result["Message"];
      console.log(result["Records"]);
      if (this.Status == "1"){

        let Records = result["Records"];
        this.BRANCH_ID = Records[0]["BRANCH_ID"];
        this.inventoryData.BRANCH_ID = Records[0]["BRANCH_ID"];
        //this.inventoryData.INVENTORY_TYPE_ID = Records[0]["INVENTORY_TYPE_ID"];
        this.inventoryData.INVENTORY_TYPE_ID = Records[0]["INVENTORY_TYPE_ID"];
        this.inventoryData.ITEM_DESC = Records[0]["ITEM_DESC"];
        this.inventoryData.COST = Records[0]["COST"];
        this.inventoryData.SELLING_PRICE = Records[0]["SELLING_PRICE"];
        this.inventoryData.INVENTORY_ACTIVE = Records[0]["INVENTORY_ACTIVE"];

        //find inventory type
        let tbl = ["All"];
        let column = ["All"];
        let value = ["All"];
        
        let tblkey = ["No"];
        let fktbl = ["No"];
        let fkkey = ["No"];
      
        let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);

        let mydata = Object.assign(jsonitem);
        let json_data = this.serviceapi.json_readdata(mydata,"1");

        this.serviceapi.readdata(json_data,"INVENTORY_TYPE","1","1").then((result) => {
          this.loading.dismiss();
          this.Status = result["Message"];
          if (this.Status == '1'){
            
            let Records = result["Records"];
            this.inventoryTypeArr = Records;
            this.inventoryTypeItems = this.inventoryTypeArr;
            if(this.mybranchid != "null")
          {
            //this.report_request.Data.BRANCH_ID = this.mybranchid;
            let tbl = ["BRANCH"];
            let column = ["BRANCH_ID"];
            let value = [this.mybranchid];
            
            let tblkey = ["No"];
            let fktbl = ["No"];
            let fkkey = ["No"];

            let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);

            let mydata = Object.assign(jsonitem);
            let json_data = this.serviceapi.json_readdata(mydata,"1");
          

            this.serviceapi.readdata(json_data,"BRANCH","1","1").then((result) => {
              
              this.Status = result["Message"];
            
              if (this.Status == '1'){
                let Records = result["Records"];
                this.mybranchname = Records[0]["BRANCH_NAME"];
              }
              else {
              
              }
            }, (err) => {
            
          
            });        
          } 
          else
          {
            let tbl = ["All"];
            let column = ["All"];
            let value = ["All"];
            
            let tblkey = ["No"];
            let fktbl = ["No"];
            let fkkey = ["No"];

            let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);

            let mydata = Object.assign(jsonitem);
            let json_data = this.serviceapi.json_readdata(mydata,"1");
           
            this.serviceapi.readdata(json_data,"BRANCH","1","1").then((result) => {
              
              this.Status = result["Message"];
              if (this.Status == '1'){
                
                let Records = result["Records"];
                this.branchArr = Records;
                this.branchItems = this.branchArr;
              }
            }, (err) => {
            
          
            });      
          }



          }
          else {
            this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
          }
        }, (err) => {
          this.errorMessage = "Loading Error. Please try again.";
          this.loading.dismiss();
        });
      }
      else {
        this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
        this.loading.dismiss();
      }
    }, (err) => {
        this.errorMessage = "Loading Error. Please try again.";
        this.loading.dismiss();
    });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad B04aInventoryInfoPage');
  }

  delete(){
    let confirm = this.alertCtrl.create({
      title: 'Confirmation',
      message: 'Are you sure you want to delete this item? This action cannot be undone.',
      buttons: [
        {
          text: 'No',
          handler: () => {
            console.log('Disagree clicked');
          }
        }, 
        {
          text: 'Yes',
          handler: () => {
            console.log('Agree clicked');
              
            this.showLoader();
            this.serviceapi.deletedata('INVENTORY', 'INVENTORY_ID', this.INVENTORY_ID).then((result) => {
          
              this.Status = result["Message"];
              if (this.Status == "1"){
                this.loading.dismiss();
                this.navCtrl.setRoot(B04cInventoryPage);
              }
              else {
                this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
                this.loading.dismiss();
              }
            }, (err) => {
                this.errorMessage = "Loading Error. Please try again.";
                this.loading.dismiss();
            });
        
          }
        }
      ]
    });
    confirm.present();
  }

  update(){
    this.showLoader();
    this.serviceapi.updatedata('INVENTORY', 'INVENTORY_ID', this.INVENTORY_ID, this.inventoryData).then((result) => {
        
      this.Status = result["Message"];
      if (this.Status == "1"){
        this.loading.dismiss();
        this.navCtrl.setRoot(B04cInventoryPage);
      }
      else {
        this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
        this.loading.dismiss();
      }
    }, (err) => {
        this.errorMessage = "Loading Error. Please try again.";
        this.loading.dismiss();
    });
  }

  cancel(){
    this.navCtrl.pop();
  }

  goTo(){
    this.navCtrl.setRoot(B04InventoryManagementPage);
  }

  goTo2(){
    this.navCtrl.setRoot(B04cInventoryPage);
  }

  showLoader(){
    this.loading = this.loadingCtrl.create({
        content: 'Loading...',
        duration: 5000
    });
    this.loading.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/b04a-inventory-info/b04a-inventory-info.ts